import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ChevronRight } from "lucide-react";
import PublicShell from "@/components/public/PublicShell";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import api from "@/lib/api";

export default function Programs() {
    const [programs, setPrograms] = useState(null);
    useEffect(() => { api.get("/programs").then((r) => setPrograms(r.data)).catch(() => setPrograms([])); }, []);

    return (
        <PublicShell>
            <section className="section-pad grid-bg">
                <div className="container-page">
                    <p className="overline">Programs</p>
                    <h1 className="mt-3 font-heading text-4xl sm:text-5xl font-extrabold tracking-tight">Career & skill programs</h1>
                    <p className="mt-4 max-w-2xl text-lg text-foreground/70">Practical, project-driven programs with mentor review, real evidence and a verifiable Digital Passport.</p>
                </div>
            </section>
            <section className="pb-24">
                <div className="container-page grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {programs === null
                        ? Array.from({ length: 5 }).map((_, i) => <Skeleton key={i} className="h-72 rounded-2xl" />)
                        : programs.map((p) => (
                            <Card key={p.slug} data-testid={`program-card-${p.slug}`} className="group flex flex-col border-border/70 hover:shadow-xl hover:-translate-y-1 transition-all">
                                <div className="p-6 flex-1">
                                    <div className="flex items-center justify-between">
                                        <Badge variant="secondary" className="rounded-full">{p.badge}</Badge>
                                        <span className="text-xs text-foreground/50 font-medium">{p.duration}</span>
                                    </div>
                                    <h3 className="mt-4 font-heading text-xl font-bold group-hover:text-primary transition-colors">{p.title}</h3>
                                    <p className="mt-2 text-sm text-foreground/60 leading-relaxed">{p.description}</p>
                                    <div className="mt-4 flex flex-wrap gap-1.5">
                                        {(p.skills || []).slice(0, 4).map((s) => <span key={s} className="text-xs rounded-full bg-muted px-2.5 py-1 text-foreground/70">{s}</span>)}
                                    </div>
                                </div>
                                <div className="p-6 pt-0 flex items-center justify-between">
                                    <span className="font-heading text-2xl font-extrabold">{p.price}</span>
                                    <Button asChild size="sm" className="rounded-full" data-testid={`program-detail-btn-${p.slug}`}>
                                        <Link to={`/programs/${p.slug}`}>Explore <ChevronRight className="ml-1 h-4 w-4" /></Link>
                                    </Button>
                                </div>
                            </Card>
                        ))}
                </div>
            </section>
        </PublicShell>
    );
}
